/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($, viewport) {

	$(window).stellar({
        responsive: true
    });

	$(window).load(function(){

		// Gallery

		if($('.gallery').length) {
			var $container = $('#gallery-container');
			$container.packery({
			  itemSelector: '.grid-item',
			  gutter: 5
			});
		}

		// Case Study Gallery
		if($('.case-study-gallery').length) {
			var $container = $('#gallery-container');
			$container.packery({
			  itemSelector: '.grid-item',
			  gutter: 5
			});
		}

		// Case Study Gallery
		if($('.case-study-gallery-btm').length) {
			var $container = $('#gallery-container-btm');
			$container.packery({
			  itemSelector: '.grid-item',
			  gutter: 5
			});
		}


		// Testimonials
		if($('.testimonial-grid').length) {
			var $container = $('.testimonial-grid');
			$container.packery({
			  itemSelector: '.page-testimonial',
			  gutter: 0
			});
		}

		// Blog

		if($('.blog-article-container').length) {
			var $container = $('.blog-article-container');
			$container.packery({
			  itemSelector: '.type-post',
			  gutter: 5
			});
		}



	});

	$(document).ready(function(){


		// Slideout Nav Bar
		$('.menu-trigger').click(function(e){

			e.preventDefault();

			$('.nav-primary').toggleClass('active');

			if($('.nav-primary').hasClass('active')) {
				$('body').addClass('no-scroll');
				$('.menu-trigger').addClass('close');
			}
			else {
				$('.menu-trigger').removeClass('close');
				$('body').removeClass('no-scroll');
			}

		});

		// Add class to navigation on scroll
		$(window).scroll(function(){
			if ($(this).scrollTop() > 200) {
			  	$('.nav-primary').addClass('fixed');
			} else {
			  	$('.nav-primary').removeClass('fixed');
			}

			if ($(this).scrollTop() > 200) {
			  	$('body').addClass('down');
			} else {
			  	$('body').removeClass('down');
			}
		});


		// Gallery popups

	    if($('.gallery').length) {

		    $(".group1").colorbox({rel:'group1',maxHeight: 700, fixed: true, top: 30});

		    function disableColorbox() {
				$.colorbox.remove();
				$(".group1").click(function(e){
					e.preventDefault();
				});
		    }

		    if(viewport.is('xs')) {
		    	disableColorbox();
		    }
		    else {
		    	$(".group1").colorbox({rel:'group1', maxHeight: 700, fixed: true, top: 30});
		    }

		    $(window).resize(
		        viewport.changed(function(){
		            if( viewport.is('xs') ) {
		              disableColorbox();
		            }
		        })
		    );

		}

		$(document).bind('cbox_load', function(){
		 	$('#cboxTitle').removeClass('on');
		});


		$(document).bind('cbox_complete', function(){
		  $('#cboxTitle').addClass('on');
		});

	 
		$('.form-start').click(function(){
			$(this).toggleClass('on').next().toggleClass('form-active');
			$(this).find('i').toggleClass('fa-angle-down fa-angle-up');
		});

		// Slick Slider -> kenwheeler.github.io/slick/

		// On swipe event
		$('.home-slider').on('init', function(event, slick){
			$(this).addClass('on');
		});

		$('.home-slider').slick({
			dots: false,
			autoplay: true,
			autoplaySpeed: 6000,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			prevArrow: '#home-slider-prev',
			nextArrow: '#home-slider-next'
		});

		// Hide link title on hover as it looks ugly
		$("a.group1").each(function(e) {
		    var title = $(this).attr('title');
		    $(this).mouseover(
		        function() {
		            $(this).attr('title','');
		        }).mouseout(
		            function() {
		            $(this).attr('title', title);
		    });
		    $(this).click(
		    function() {
		        $(this).attr('title', title);
		        }
		    );
		});

		// Select2 -> https://select2.github.io/

		var $formSelect = $('select').select2({
	  		minimumResultsForSearch: Infinity
		});

		$('b[role="presentation"]').hide();
		$('.select2-selection__arrow').append('<i class="icon icon-form-arrow"></i>');


		$formSelect.on("select2:open", function (e) { 
			$('.select2-selection__arrow').find('i').removeClass('icon-form-arrow').addClass('icon-form-arrow-down');
		});

		$formSelect.on("select2:close", function (e) { 
			$('.select2-selection__arrow').find('i').removeClass('icon-form-arrow-down').addClass('icon-form-arrow');
		});

	});

	// Animated Header -> http://tympanus.net/Blueprints/AnimatedHeader/

	var $header = $(".burton-header"),
		$clone = $header.before($header.clone(true, true).addClass("clone"));




})(jQuery, ResponsiveBootstrapToolkit); // Fully reference jQuery after this point.
